@let text = getSignal('text')();
@let image = getSignal('image')();
@let contactButton = getSignal('contactButton')();
<div class="content-container">
    @if(image.success) {
        <app-editable-image 
            [elemId]="image.payload" 
            [imageReference]="imageReference"
            [fileTypes]="supportedFileTypes"
            [maxWidth]="1920"
            [maxHeight]="1080"
            [customClass]="'single-column-text-image-custom-class-image custom-elevation-z2'">
        </app-editable-image>
    }
    @if(text.success) {
    <div class="content">
        <app-editable-text 
            [elemId]="text.payload"
            [customClass]="'custom-title-medium'">
        </app-editable-text>
    </div>
    }
</div>
@if(contactButton.success) {
    <app-editable-button 
        [elemId]="contactButton.payload"
        [customClass]="'base-card-custom-class-button'">
    </app-editable-button>
}